import { render, staticRenderFns } from "./addPaymentGateways.vue?vue&type=template&id=4de10006&lang=true"
import script from "./addPaymentGateways.vue?vue&type=script&lang=js"
export * from "./addPaymentGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports